/** scratch pad for detail-grid. will be cleaned up */

import {
    goalVariancePercent,
    PerformanceData,
    targetVariancePercent,
} from '../../coaching-insight/oa/models/oa.model';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getPercentages(l: PerformanceData) {
    if (l.actual) {
        l.targetPercent = targetVariancePercent(
            l.actual,
            l.target,
            l.rankOrder === 0 ? -1 : 1,
        );
        l.goalPercent = goalVariancePercent(
            l.actual,
            l.goal,
            l.rankOrder === 0 ? -1 : 1,
        );
    }
}

export function getTrendName(l: PerformanceData): PerformanceData {
    const td = l.trend.split(' ');
    if (td.length) {
        if (td?.[1] != null) {
            l.arrow = td[1].toLowerCase();
        }
        if (td?.[0] != null) {
            l.arrowColour = td[0].toLowerCase();
        }
    }
    return l;
}

export function calculateGap(l: PerformanceData): number {
    return (
        (((l.actual - l.target) / l.target) * (l.rankOrder === 0 ? -1 : 1) -
            // - (this.activeMetric.oaThresholdValue)
            // - (0.01)
            0) *
        l.target
    );
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getThreshold() {
    /** return this.activeMetric.oaThresholdValue * 100;
    return 0.01 * 100; */
    return 0;
}
